(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cm-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cm-size-guide')) {
  customElements.define('cm-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const details = this.querySelector('details');
      const trigger = this.querySelector('summary');
      const dialog = this.querySelector('dialog');
      const content = this.querySelector('.cm-size-fallback');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        if (dialog.open) return;
        dialog.append(content);
        dialog.showModal();
        trigger.setAttribute('aria-expanded', 'true');
      });
      dialog.addEventListener('close', () => {
        details.append(content);
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus({preventScroll:true});
      });
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
